<template>
    <div style="margin: 2rem">
        <div class="row support-page-layout">
            <div class="col-sm-12 col-md-7 content-section" style="font-size: 16px">
                <h1>{{ $t('why_support') }}</h1>
                <p>{{$t('legacy_media')}}</p>
                <p>{{$t('we_dont_care')}}</p>
                <p>{{$t('if_you_have_gone_this_far')}}</p>
            </div>

            <div class="col-sm-12 col-md-5 support-section">
                <div class="support-popup-page">
                    <div class="row">
                        <div class="support-popup-top">
                            <h1>{{ $t('support_us') }}</h1>
                            <p>{{ $t('please_select_how_you_want_to_make_a_donation') }}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="credit-card col-md-12">
                            <div class="row">
                                <div class="col-md-6">
                                    <p><img src="/assets/images/credit-card.svg" alt=""/> Credit Card</p>
                                </div>
                                <div class="col-md-6">
                                    <footer style="padding-top: 0; background: unset; margin-top: 0">
                                        <div class="footer-Newsletter-input" v-if="$store.state.language.code !== 'tr'">
                                            <form :action="$store.state.hrefPrefix + '/support-us/pay'" method="post"
                                                  ref="support" @submit.prevent="">
                                                <input type="hidden" name="_token" :value="csrf">
                                                <div class="support-presets">
                                                    <button v-for="preset in presets" :key="preset" type="button"
                                                            :class="{ active: amount === preset }"
                                                            @click="amount = preset">
                                                        ${{ preset }}
                                                    </button>
                                                </div>
                                                <div class="Newsletter-input">
                                                    <input type="number" min="1" required v-model.number="amount"
                                                           :placeholder="$t('amount_usd')" name="amount"/>
                                                    <button style="width: 100%" class="g-recaptcha"
                                                            :disabled="submitting"
                                                            data-sitekey="6Ld3Xv8mAAAAAJSdwXb6BysaOps8-vQJMk9W_ej5"
                                                            data-callback="submitSupportFromPage">
                                                        <i v-if="submitting" class="fa-solid fa-spinner fa-spin"></i>
                                                        <template v-else>{{ $t('SUPPORT') }}</template>
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </footer>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SupportPopup from "@/parts/home/TopBar/SupportPopup.vue";

export default {
    name: "SupportUsPage",
    components: {SupportPopup},
    data() {
        return {
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            amount: null,
            presets: [5, 25, 50],
            submitting: false,
        }
    },

    methods: {
        copyTRONAddressToClipboard() {
            const address = 'TEyZtrShUqFdmHYeiqYyvMc3DnYWKrcSkV';
            navigator.clipboard.writeText(address);
            alert('Address copied to clipboard!');
        },

        copyBTCAddressToClipboard() {
            const address = 'bc1qd864czk7zrrvuf5uvm0f6fecfn78mt6w8e0356';
            navigator.clipboard.writeText(address);
            alert('Address copied to clipboard!');
        },

        submitSupport(response) {
            if (this.submitting) {
                return;
            }
            const form = this.$refs.support;
            if (!form.reportValidity()) {
                try {
                    window.grecaptcha.reset();
                } catch (e) {
                }
                return;
            }
            this.submitting = true;
            form.submit();
        }
    },

    mounted() {
        window.submitSupportFromPage = this.submitSupport;
    }
}
</script>

<style scoped>
.support-presets {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 0.75rem;
}

.support-presets button {
    flex: 1;
    height: 40px;
    background-color: var(--cdl-white);
    color: var(--cdl-primary);
    border: 1px solid var(--cdl-primary);
    font-size: 1rem;
    font-weight: 700;
    cursor: pointer;
}

.support-presets button:hover,
.support-presets button.active {
    background-color: var(--cdl-primary);
    color: var(--cdl-white);
}

.Newsletter-input button:disabled,
.Newsletter-input button:disabled:hover {
    background-color: var(--cdl-primary);
    color: var(--cdl-white);
    opacity: 0.7;
    cursor: not-allowed;
}

.support-page-layout {
    display: flex;
    flex-wrap: wrap;
}

@media (max-width: 767px) {
    .content-section {
        order: 1;
    }

    .support-section {
        order: 2;
    }
}

@media (min-width: 768px) {
    .content-section {
        order: 1;
    }

    .support-section {
        order: 2;
    }
}

.footer-Support {
    width: 143px;
    height: 42px;
    display: flex;
    align-items: center;
    font-size: 1.2rem;
    font-weight: 700;
    margin: 3rem auto 0;
    background-color: var(--cdl-primary);
    padding: 0;
    color: var(--cdl-white);
    justify-content: center;
    cursor: pointer;
    border: 0;
}

.footer-Support:hover {
    background-color: var(--cdl-white);
    color: var(--cdl-primary);
}

.footer-Support:hover i {
    filter: none;
}

.footer-Support i {
    filter: brightness(0) invert(1);
}
</style>
